<div
  class="order-request-static-cards order-request-static-cards--prepaid"
  *ngIf="!loading; else prepaidCardsLoading"
>
  <div
    class="order-request-static-card order-request-static-card--selectable"
    *ngFor="
      let book of host.orderRequestPrepaidBooks;
      trackBy: host.trackOrderRequestPrepaidBookById
    "
    [class.order-request-static-card--themed]="!!host.themeColorForPrepaid(book)"
    [class.order-request-static-card--selected]="host.isOrderRequestPrepaidSelected(book.id)"
    [class.order-request-static-card--disabled]="host.isOrderRequestPrepaidDisabled()"
    (click)="onSelect(book.id, $event)"
    role="radio"
    [attr.aria-checked]="host.isOrderRequestPrepaidSelected(book.id)"
    [attr.aria-disabled]="host.isOrderRequestPrepaidDisabled()"
    [tabindex]="selectable && !host.isOrderRequestPrepaidDisabled() ? 0 : -1"
    (keydown.enter)="onSelect(book.id, $event)"
    (keydown.space)="onSelect(book.id, $event)"
  >
    <span
      *ngIf="host.themeColorForPrepaid(book) as prepaidTheme"
      class="order-request-theme-fill"
      [class.order-request-theme-fill--light]="host.isLightTheme(prepaidTheme)"
      [style.background]="prepaidTheme"
      aria-hidden="true"
    ></span>
    <span class="order-request-static-card__title" [attr.title]="book.name">{{ book.name }}</span>
    <ng-container *ngIf="selectable">
      <span
        class="order-request-static-card__sub"
        *ngIf="host.formatOrderRequestPrepaidSellingPrice(book) as prepaidPrice"
        >{{ prepaidPrice }}</span
      >
    </ng-container>
  </div>
</div>
<ng-template #prepaidCardsLoading>
  <ng-container *ngTemplateOutlet="host.orderRequestCardsShimmer"></ng-container>
</ng-template>
